export default __webpack_public_path__ + "static/media/action-pause_white.84ecef3e.svg";